import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { imageToPicture, PlainImageSection } from '../../../app/components/plain-image/plain-image.component';
import { SectionComponent } from '../../components/section/section.component';

import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { Section, SectionAttributes } from '../../../app/types/section';
import { iconInfo } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { HtmlComponent } from '@knorr-bremse-portals/ngx-components/components/html';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type InfoBoxSection = Section<
  {
    numColumns: 4 | 8;
    headline?: string;
    boxHeadline?: string;
    image?: PlainImageSection;
    text: string;
    backgroundColor?: 'beige' | 'white' | 'blue';
    icon?: 'none' | 'info';
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'boxHeadline',
    'image',
    'text',
    'backgroundColor',
  ],
  'info-box'
>;

@Component({
  selector: 'app-info-box',
  styleUrls: ['./info-box.component.scss'],
  templateUrl: './info-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    OgImageDirective,
    CardComponent,
    HtmlComponent,
    PictureComponent,
    IconComponent,
    FsButtonComponent,
],
})
export class InfoBoxComponent extends SectionComponent<InfoBoxSection> {

  protected iconInfo = iconInfo;

  protected imageToPicture = imageToPicture;
  protected standardAspectRatio = AspectRatio.Standard;
  protected ultrawideAspectRatio = AspectRatio.Ultrawide;

}
